import React, { Component } from 'react';
import Header from '../../components/main.header.component';

class ToDo extends Component {
  componentDidMount() {
    window.scrollTo(0,0);
  }
  render() {
    return (
      <div className="todo-body">
        <Header
          props={this.props}
        />
        <div className="todo-headline">
          Yes, another To-Do list!
        </div>
        <div className="todo-text">
          (I didn't realize they were so over-done when I made this, I swear)<p />
            But this one was made based around using the Futura font for a joke!
            <br />
            <br />
          Things To-Do in the <em>Futura...</em> get it??
        </div>
        <div className="todo-link">
          <a href="https://github.com/cozpon/to-do" target='_blank' rel="noopener noreferrer">
            See the repository on Github.
          </a>
        </div>
        <div className="todo-color">
          <img src="/images/design/To-Do.gif" className="todo-gif" alt="todo" />
        </div>
        <div className="todo-built">
          <h2>Built with:</h2>
          <ul>
            <li>React.js</li>
            <li>Express</li>
            <li>Node.js</li>
            <li>PostgreSQL</li>
            <li>SASS</li>
          </ul>
          <h5>Deployed on Digital Ocean using Apache and Nginx</h5>
        </div>
      </div>
    );
  }
}

export default ToDo;



